import React from "react";

interface Props {
  value: number;
  max: number;
  color: "aquamarine-600"|"orange-300"|"orange-500"|"cherry-600"|"blue";
  height?: string;
  width?: string;
}

const ValueBar: React.FC<Props> = ({
  value,
  max,
  color,
  height = "8px",
  width = "100%",
}) => {
  const percent = (100 * value / max) + "%"


  return (
    <div style={{height: height, width: width}} className="rounded-sm bg-neutral-400">
        <div className={"rounded-sm bg-" + color} style={{height: height, width: percent}}/>
    </div>
  );
};

export default ValueBar;
